import { FieldArray } from "formik";
import { Box, TextField, MenuItem, IconButton, Typography } from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";


const ContributionRate = ({ values, setFieldValue, contributionCodes }) => {
  return (
    <FieldArray
      name="contributionRate"
      render={(arrayHelpers) => (
        <Box display="flex" flexDirection="column" gap={2}>
          {values.contributionRate?.length > 0 ? (
            values.contributionRate.map((rate, index) => (
              <Box
                key={index}
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap={2}
                alignItems="center"
              >
                {/* Contribution Codes */}
                <TextField
                  select
                  fullWidth
                  variant="filled"
                  label="Contribution Code"
                  name={`contributionRate.${index}.contributionCode`}
                  value={rate.contributionCode || ''}
                  onChange={(e) =>
                    setFieldValue(`contributionRate.${index}.contributionCode`, e.target.value)
                  }
                  // SelectProps={{ multiple: true }}
                  sx={{ gridColumn: "span 5" }}
                >
                  {contributionCodes?.map((r) => (
                    <MenuItem key={r.contributionCode} value={r.contributionCode}>
                      {`${r.contributionCode} - ${r.description}`}
                    </MenuItem>
                  ))}
                </TextField>

                {/* Employee Rate */}
                <TextField
                  fullWidth
                  variant="filled"
                  type="number"
                  label="Employee Rate (%)"
                  name={`contributionRate.${index}.employeeRate`}
                  value={rate.employeeRate || 0}
                  onChange={(e) =>
                    setFieldValue(`contributionRate.${index}.employeeRate`, e.target.value)
                  }
                  slotProps={{
                    input: { sx: { "& input": { textAlign: "right" } } },
                  }}
                  sx={{ gridColumn: "span 1" }}
                />

                {/* Employer Rate */}
                <TextField
                  fullWidth
                  variant="filled"
                  type="number"
                  label="Employer Rate (%)"
                  name={`contributionRate.${index}.employerRate`}
                  value={rate.employerRate || 0}
                  onChange={(e) =>
                    setFieldValue(`contributionRate.${index}.employerRate`, e.target.value)
                  }
                  slotProps={{
                    input: { sx: { "& input": { textAlign: "right" } } },
                  }}
                  sx={{ gridColumn: "span 1" }}
                />
                
                {/* Minimum Contribution Base */}
                <TextField
                  fullWidth
                  variant="filled"
                  type="number"
                  label="Minimum Contribution Base"
                  name={`contributionRate.${index}.minContributionBase`}
                  value={rate.minContributionBase || 0}
                  onChange={(e) =>
                    setFieldValue(`contributionRate.${index}.minContributionBase`, e.target.value)
                  }
                  slotProps={{
                    input: { sx: { "& input": { textAlign: "right" } } },
                  }}
                  sx={{ gridColumn: "span 2" }}
                />

                {/* Maximum Contribution Base */}
                <TextField
                  fullWidth
                  variant="filled"
                  type="number"
                  label="Maximum Contribution Base"
                  name={`contributionRate.${index}.maxContributionBase`}
                  value={rate.maxContributionBase || 0}
                  onChange={(e) =>
                    setFieldValue(`contributionRate.${index}.maxContributionBase`, e.target.value)
                  }
                  slotProps={{
                    input: { sx: { "& input": { textAlign: "right" } } },
                  }}
                  sx={{ gridColumn: "span 2" }}
                />

                {/* Remove */}
                <Box sx={{ gridColumn: "span 1", textAlign: "center" }}>
                  <IconButton 
                    size="large"
                    onClick={() => arrayHelpers.remove(index)} 
                    // sx={{ gridColumn: "span 1" }}
                  >
                    <RemoveCircle color="error" />
                  </IconButton>
                </Box>
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No contribution rate added.
            </Typography>
          )}

          {/* Add button */}
          <Box>
            <IconButton
              aria-label="add-rate"
              onClick={() =>
                arrayHelpers.push({
                  contributionCode: [],
                  contributionType: "",
                  employeeRate: 0,
                  employerRate: 0,
                })
              }
              size="large"
              color="primary"
            >
              <AddCircle />
            </IconButton>
          </Box>
        </Box>
      )}
    />
  );
};

export default ContributionRate;
